var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 14.6668H3.33331C2.80288 14.6668 2.29417 14.4561 1.9191 14.081C1.54403 13.706 1.33331 13.1973 1.33331 12.6668V2.00016C1.33331 1.82335 1.40355 1.65378 1.52858 1.52876C1.6536 1.40373 1.82317 1.3335 1.99998 1.3335H11.3333C11.5101 1.3335 11.6797 1.40373 11.8047 1.52876C11.9297 1.65378 12 1.82335 12 2.00016V10.0002H14.6666V12.6668C14.6666 13.1973 14.4559 13.706 14.0809 14.081C13.7058 14.4561 13.1971 14.6668 12.6666 14.6668ZM12 11.3335V12.6668C12 12.8436 12.0702 13.0132 12.1952 13.1382C12.3203 13.2633 12.4898 13.3335 12.6666 13.3335C12.8435 13.3335 13.013 13.2633 13.1381 13.1382C13.2631 13.0132 13.3333 12.8436 13.3333 12.6668V11.3335H12ZM10.6666 13.3335V2.66683H2.66665V12.6668C2.66665 12.8436 2.73688 13.0132 2.86191 13.1382C2.98693 13.2633 3.1565 13.3335 3.33331 13.3335H10.6666ZM3.99998 4.66683H9.33331V6.00016H3.99998V4.66683ZM3.99998 7.3335H9.33331V8.66683H3.99998V7.3335ZM3.99998 10.0002H7.33331V11.3335H3.99998V10.0002Z",
    fill: "#484B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionBill);
export default __webpack_public_path__ + "static/media/action-bill.b2dd21535eda43ae82d9862e4ff3f6f7.svg";
export { ForwardRef as ReactComponent };